import AddIcon from '@mui/icons-material/Add'
import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import Button from '@/components/Button'
import { clearSelectedCases, clearTrashSelectedCases } from '@/store/project'

import NewProject from './NewProject'

interface ProjectsHeaderProps {
  refetchRecipe: () => void
}

const ProjectsHeader: React.FC<ProjectsHeaderProps> = ({ refetchRecipe }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'project',
  })

  const dispatch = useDispatch()
  const [createProject, setCreateProject] = useState<boolean>(false)

  const handleNewProject = () => {
    setCreateProject(true)
    dispatch(clearSelectedCases())
    dispatch(clearTrashSelectedCases())
  }

  return (
    <Box display="flex" justifyContent="space-between" mb={4}>
      <Typography fontSize={'32px'} fontWeight={700} color="white">
        {t('projects')}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        label={t('newProject')}
        size="large"
        onClick={handleNewProject}
        startIcon={<AddIcon />}
        textTransform="uppercase"
      />
      {createProject && (
        <NewProject
          open={createProject}
          onClose={() => setCreateProject(false)}
          refetchRecipe={refetchRecipe}
        />
      )}
    </Box>
  )
}

export default ProjectsHeader
